export { ReactComponent as NumberedList } from './svgs/numbered-list.svg';
